// extracted by mini-css-extract-plugin
export default {"padding":"6rem","padding-top":"7rem","paddingTop":"7rem","nav-up":"3rem","navUp":"3rem"};